var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapMarker = function SvgMapMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "796 796 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M970.135 870.134C970.135 829.191 936.943 796 896 796s-74.135 33.191-74.135 74.134c0 16.217 5.221 31.206 14.055 43.41l-.019.003L896 996l60.099-82.453-.019-.003c8.832-12.204 14.055-27.193 14.055-43.41M896 900.006c-16.497 0-29.871-13.374-29.871-29.872s13.374-29.871 29.871-29.871 29.871 13.373 29.871 29.871-13.374 29.872-29.871 29.872"
  })));
};
export default SvgMapMarker;